module.exports = __webpack_public_path__ + "static/media/notifyIcon.f4f43f1b.svg";